import type { SVGProps } from 'react';
import { IconBase } from './icon-base';

export function DotIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <circle cx="12.1" cy="12.1" r="1" />
    </IconBase>
  );
}
